<template>
    <div class="agreement-content">
        <div class="agreement-container">
            <div class="container-title">主体信息</div>
            <div class="container-body" >
                <el-form label-width="100px" :inline="true">
                    <el-col :span="8">
                        <el-form-item label="协议编号:">
                            <div class="ellipsis" >{{agreementDetail.agreementCode}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议名称:">
                            <div  class="ellipsis" >{{agreementDetail.agreementName}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议发起方:">
                            <div   class="ellipsis" >易派客电子商务有限公司</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议甲方企业:">
                            <div   class="ellipsis" >{{agreementDetail.firstCompanyName}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议乙方企业:">
                            <div class="ellipsis" > <e-tooltip
                                    :content="agreementDetail.secondCompanyName"
                                    :set-length="15" style="display: inline-block" /></div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="乙方类型:">
                            <div   class="ellipsis" >{{formatSecondCompanyType(agreementDetail.secondCompanyType)}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议有效时间:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.startDate + '至' + agreementDetail.endDate}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="服务费率:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.serviceRate + '%'}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="协议状态:" prop="date">
                            <div   class="ellipsis" >{{formatStatus(agreementDetail.agreementStatus)}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="审核状态:" prop="date">
                            <div   class="ellipsis"  :class="{'danger' : [3, 5].includes(agreementDetail.auditStatus) }">
                                {{formatAuditStatus(agreementDetail.auditStatus)}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.contact}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系方式:" prop="date">
                            <div   class="ellipsis" >{{agreementDetail.telephone}}</div>
                        </el-form-item>
                    </el-col>


                    <el-col :span="16">
                        <el-form-item label="备注:" prop="remark">
                            <div   class="ellipsis" >{{agreementDetail.remark}}</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="附件:">
                            <el-button type="text" @click="checkAttachList">查看附件列表</el-button>
                        </el-form-item>
                    </el-col>

                </el-form>

            </div>
        </div>

        <div class="agreement-container">
            <div class="container-title">物料分类清单</div>
            <div class="margin-b10">
                物料类别名称：
                <el-input v-model="queryParams.categoryName" placeholder="请输入物料类别名称" style="width: 180px;margin-right: 10px"></el-input>
                <el-button type="primary" plain @click="resetData">重置</el-button>
                <el-button type="primary" class="margin-l10" @click="getAgreementCategroyInShared">查询</el-button>
            </div>
            <div class="container-body">
                <div style="margin-right: 20px;display: flex">
                    <TableList
                            style="width: 50%"
                            key="1"
                            :loading="loading1"
                            :table-data="tableData1"
                            :table-label="tableLabel"
                            :index-show="false"
                            @handleButton="handleButton"
                            @handleSortChange="handleSortChange"
                            @handleSelectionChange="handleSelectionChange"
                    >
                    </TableList>
                    <TableList
                            v-if="tableData2.length > 0"
                            style="width: 50%"
                            key="2"
                            :loading="loading2"
                            :table-data="tableData2"
                            :table-label="tableLabel"
                            :index-show="false"
                            @handleButton="handleButton"
                            @handleSortChange="handleSortChange"
                            @handleSelectionChange="handleSelectionChange"
                    >
                    </TableList>

                </div>
                <div class="pagination">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                            layout="total, sizes, prev, pager, next, jumper"
                            :current-page="queryParams.pageNum"
                            :page-size="queryParams.pageSize"
                            :total="queryParams.pageTotal"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>

        <div class="agreement-container">
            <div class="container-title">操作记录</div>

            <div class="container-body" >
                <el-form label-width="100px" :inline="true">
                    <el-col :span="12">
                        <el-form-item label="创建人:">
                            {{agreementDetail.createUser}}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="创建时间:">
                            {{agreementDetail.createTime}}
                        </el-form-item>
                    </el-col>
                </el-form>
            </div>

        </div>
        <div  class="agreement-container" v-if="auditRecord.length > 0">
            <div class="container-title">审核记录</div>
            <div class="container-body" >
                <el-row v-for=" (item,index) in auditRecord" :key="index" class="aduit-wrapper">
                    <el-col :span="4"><span >审核人:{{item.createUser}}</span> </el-col>
                    <el-col :span="6"><span >审核时间:{{item.createTime}}</span></el-col>
                    <!--  2-审核通过 3-审核拒绝-->
                    <el-col :span="4"><span >审核结果:
                  <span :class="{'danger' : Number(item.auditStatus) === 3 }">{{ handleAuditStatus(item.auditStatus)}}</span></span>
                    </el-col>
                    <el-col :span="10" ><div>拒绝原因:
                        <e-tooltip
                                :content="item.refuseReason"
                                :set-length="16" style="display: inline-block" :class="{'danger' : item.refuseReason }"/>
                    </div></el-col>
                </el-row>
            </div>
        </div>
        <div style="margin-top: 10px">
            <!-- 只有协议状态拒绝才可以编辑-->
<!--            <el-button @click="handleEdit" type="primary" v-if="[3, 5].includes(agreementDetail.auditStatus)">编辑</el-button>-->
            <el-button @click="handleCancel">返回</el-button>
        </div>
        <AttachListDialog v-if="checkAttachDialog" :agreementId="agreementId"  :visible="checkAttachDialog"  @close="() => { this.checkAttachDialog = false}" ></AttachListDialog>

    </div>
</template>

<script>
    import TableList from '../../components/common/e-table-list'
    import Api from '../../api/agreement/index'
    import AttachListDialog from '../../components/agreement/agreementManage/attachListDialog';
    import eTooltip from "../../components/common/e-tooltip";
    export default {
        name: "agreementDetail",
        components: {
            TableList,
            AttachListDialog,
            eTooltip
        },
        props: {
        },
        data() {
            return {
                queryParams:{
                    categoryName:'',
                    pageNum:1,
                    pageSize:10,
                    pageTotal: 0,
                    agreementId:'',
                },
                agreementDetail:{
                  serviceRate: '',
                  startDate: '',
                  endDate: ''
                },
                loading1:false,
                tableData1:[],
                agreementConfirm:1,
                indexShow:true,
                loading2:false,
                tableData2:[],
                tableLabel: [
                    { label: '序号', param: 'index', align: 'center',width:'50px'},
                    { label: '物料类别', param: 'categoryName', align: 'center'},
                ],
                categoryVisible:false,
                editFlag:false,
                checkAttachDialog:false,
                agreementId:this.$route.query.agreementId,
                auditRecord:[],
            }
        },
        computed: {},
        created() {
            this.queryParams.agreementId =  this.$route.query.agreementId;
            this.getAgreementDetail()
            this.getAgreementCategroyInShared();
            this.queryAgreementAuditRecord();
        },
        methods: {
            //获取审核数据
            async queryAgreementAuditRecord(){
                let res = await Api.queryAgreementAuditRecord({agreementId:this.queryParams.agreementId});
                if(parseInt(res.code) === 200){
                    this.auditRecord = res.data;
                }
            },
            resetData(){
                this.queryParams.categoryName = '';
                this.getAgreementCategroyInShared();
            },
            handleAuditStatus(auditStatus){
                let status = '';
                if(auditStatus === 2){
                    status = '审核通过';
                }else if(auditStatus === 3){
                    status = '审核拒绝';
                }
                return status;
            },
            handleButton(){
            },
            handleSortChange(){},
            handleSelectionChange(){},
            //获取协议内物料分类
            async getAgreementCategroyInShared(){
                this.tableData1=[]
                this.tableData2=[]

                let res = await Api.queryAgreementCategoryPage(this.queryParams)

                if(res.data){
                    this.loading1 = false
                    this.loading2 = false
                    for(let i=0;i<res.data.records.length;i++){
                        if((i+1) % 2 == 0){
                            this.$set(res.data.records[i],'index', i+1)
                            this.tableData2.push(res.data.records[i])
                        }else {
                            this.$set(res.data.records[i],'index', i+1)
                            this.tableData1.push(res.data.records[i])
                        }
                    }
                     this.queryParams.pageTotal = res.data.total


                }
            },
            async getAgreementDetail(){
                let params = {
                    agreementId: this.$route.query.agreementId
                }
                let res = await Api.getSharedAgreementDetail(params)
                if(res.data){
                    this.agreementDetail = res.data
                }
            },
            handleCancel(){
                this.$router.push({path:'/sharedResourceAgreementManage'})
            },
            // handleEdit(){
            //     this.$router.push({path:'/shareAgreementEdit',query:{agreementId:this.$route.query.agreementId}})
            // },
            checkAttachList(){
                this.checkAttachDialog = true
            },
            formatStatus(val){
                let res =''
                switch (val) {
                    case 0: res='待维护商品';break;
                    case 1: res='待生效';break;
                    case 2: res='已生效';break;
                    case 3: res='已失效';break;
                    case 4: res='待审核商品';break;
                    case 5: res='已停用';break;
                    case 6: res='待平台审核';break;
                    case 7: res='审核拒绝';break;
                }
                return res
            },
            //审核状态
            formatAuditStatus(val){
                let str = null;
                switch (val) {
                    case 1:str = '待初审';break;
                    case 2:str = '审核通过';break;
                    case 3:str = '初审拒绝';break;
                    case 4:str = '待复审';break;
                    case 5:str = '复审拒绝';break;
                    default:str = '';
                }
                return str
            },
            formatSecondCompanyType(val){
                let res =''
                switch (val) {
                    case 0: res='生产商';break;
                    case 1: res='流通商';break;
                    case 2: res='代理商';break;
                }
                return res
            },
            handleSizeChange(val){
                this.queryParams.pageSize = val;
                this.queryParams.pageNum = 1;
                this.getAgreementCategroyInShared()
            },
            handleCurrentChange(val){
                this.queryParams.pageNum = val;
                this.getAgreementCategroyInShared()
            }
        }

    }
</script>

<style lang="scss" scoped>
    .agreement-content{
        display:flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .agreement-container{
            background: #fff;
            margin-bottom: 10px;
            box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 20px;
            .container-title{
                font-size: 16px;
                color: #333;
                margin-bottom: 20px;
                width: 100%;
            }
            .container-body{
                width: 100%;
                .aduit-wrapper{
                    font-size: 14px;
                    margin-left: 20px;
                }
                .el-input-width{
                    width: 266px;
                    height: 28px;
                }
                .container-purchase{
                    background: #F8F8F8;
                    width: 725px;
                    height: 424px;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    .left{
                        width: 308px;
                        height: 360px;
                        background-color: #FFFFFF;
                        padding: 10px 10px 10px;
                        .search{
                            width: 100%;
                            .scrollbar{
                                height: 242px;
                                overflow: hidden;
                            }
                        }
                    }
                    .right{
                        width: 298px;
                        height: 360px;
                        background-color: #FFFFFF;
                        padding: 10px 10px 10px;
                        .scrollbar{
                            height: 316px;
                            overflow: hidden;
                            .scrollbar-li{
                                display: flex;
                                justify-content: space-between;
                                cursor: pointer
                            }
                            .scrollbar-active{
                                background: #F4F7FF;
                            }
                        }
                    }
                    .middle{
                        width: 60px;
                        height: 360px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        img{
                            height: 35px;
                            width: 18px;
                        }
                    }
                    .tip{
                        font-size: 14px;
                        color: #999999;
                    }
                }
                .tabs-area{
                    margin-bottom: 20px;
                    .scrollbar{
                        height: 290px;
                        overflow: hidden;
                        .table{
                            display: flex;
                            flex-direction: row;
                        }
                    }
                }
            }

        }
    }

    .scrollbar ::v-deep .el-scrollbar__wrap{
        overflow: hidden;
        margin-right: 0 !important;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-vertical{
        background: #F5F5F5;
        border-radius: 2px;
        width: 3px;
        opacity: 1;
        margin-right: -2px;
    }
    .scrollbar ::v-deep .el-scrollbar__bar.is-horizontal{
        background: #F5F5F5;
        border-radius: 2px;
        height: 3px;
        margin-bottom: -2px;
        &:hover{
            opacity: 0;
        }
    }
    .tabs-area ::v-deep .el-tabs__header{
        margin: 0 0 0 !important;
    }
    .tabs-area ::v-deep .el-tabs__header .el-tabs__nav{
        border-radius: 0 !important;
    }
    .table ::v-deep .el-table__empty-block{
        min-height: 0 !important;
    }
    .table ::v-deep .el-table__empty-text{
        display: none;
    }
    ::v-deep {
        .el-rate__icon {
            font-size: 20px;
            margin-right: 2px;
        }

        .tabs-area {

            .el-tabs__nav {
                border-radius: 0;
            }

            .el-tabs__header {
                margin-bottom: 0;
            }

            .el-tabs__nav .el-tabs__item {
                width: 176px;
                text-align: center;
                font-size: 14px;
                line-height: 40px;
                height: 40px;

                &.is-active {
                    background: #F4F7FF;
                    color: #0064C8;
                }

                &.is-active::after {
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 0;
                    content: '';
                    width: 100%;
                    height: 2px;
                    background: #0064C8;
                }
            }
            .el-tabs__content{
                border-left:1px solid #ebeef5;
                border-right:1px solid #ebeef5;
                border-bottom:1px solid #ebeef5;
            }
        }
    }
</style>
